/* eslint-disable no-console */

export const prettyPrintTealiumEvent = (obj) => {
  const objString = JSON.stringify(obj, undefined, 2);
  console.log('------------------------------------------------');
  console.log(`tagging event fired on page ${window.location.href}\n`);
  console.log(objString);
  console.log('\n\n');
};
